__turbopack_context__.v({
  "header": "membership-requirements-module-scss-module__vflNMa__header",
  "header__country-selector": "membership-requirements-module-scss-module__vflNMa__header__country-selector",
  "header__dropdown-skeleton": "membership-requirements-module-scss-module__vflNMa__header__dropdown-skeleton",
  "header__year-selector": "membership-requirements-module-scss-module__vflNMa__header__year-selector",
  "production-table": "membership-requirements-module-scss-module__vflNMa__production-table",
  "requirements-wrapper": "membership-requirements-module-scss-module__vflNMa__requirements-wrapper",
});
